'use strict';

require('./HeaderWithBanner.scss');

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
  {AppBar, LeftNav, MenuItem, Styles, Avatar, FontIcon, IconButton} = require('material-ui'),
  AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
  Carousel = require('components/Commons/Carousel/Carousel'),
  CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
  {getIconMenu} = require('components/Header/Header'),
  DashboardServiceCache = require('services/DashboardServiceCache'),
  Security = require('services/Security').auth,
  $ = require('jquery'),
  ga = require('react-ga'),
  Constants = require('constants/AppConstants'),
  get = require('lodash/object').get,
  SettingModal = require('./SettingModal/SettingModal'),
  ActionTypes = require('constants/AppConstants').ActionTypes,
  SessionStore = require('stores/SessionStore'),
  Colors = Styles.Colors,
  ContentUtils = require('utils/ContentUtils'),
  PositionUtils = require('utils/PositionUtils'),
  actions = require('constants/AppConstants').Analytics.actions,
  categories = require('constants/AppConstants').Analytics.categories;

const HeaderSideBar = React.createClass({displayName: "HeaderSideBar",
  render: function () {
    return (
      React.createElement("div", {className: "nav-bar-header is-free-version hidden-xs"}, 
        React.createElement("img", {src: "/assets/images/logo-small.png"})
      )
    );
  }
});

const imageList = [
  {
    imgSrc: '/assets/images/banner-v3.gif',
    name: 'Brewplanner LLC',
    link: 'https://www.brewplanner.com/videos',
    index: 0
  },
  {
    imgSrc: '/assets/images/banner-v3.gif',
    name: 'Brewplanner LLC',
    link: 'https://www.brewplanner.com/videos',
    index: 1
  },
  {
    imgSrc: '/assets/images/banner-v3.gif',
    name: 'Brewplanner LLC',
    link: 'https://www.brewplanner.com/videos',
    index: 2
  }
];

const DASHBOARD_ID ='#dashboard-id';

const Header = React.createClass({displayName: "Header",
  
  contextTypes: {
    router: React.PropTypes.func
  },
  
  
  getInitialState() {
    return {
      isSettingModalOpen: false
    };
  },
  
  _toggleSettingModalShow() {
    this.setState(prevState => {
      return {
        isSettingModalOpen: !prevState.isSettingModalOpen
      };
    });
  },
  
  _onExit() {
    if (DashboardServiceCache.getPendingOperations().length > 0) {
      CustomDialog.showWarningConfirmation(t('warning'), t('notification_warning_leave_dashboard_before_auto_saved'),
        () => {
          this._logout();
        },
        t('button_label_continue'),
        t('button_label_cancel'));
    } else {
      this._logout();
    }
  },
  
  _logout() {
    Security.logout();
    ga.event({
      category: categories.APPLICATION,
      action: actions.SIGN_OUT,
      label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
    });
  },
  
  _printDashboard(e) {
    e.preventDefault();
    
    // remove selection dashboard to avoid problem when print the orders
    AppDispatcher.dispatch({type: ActionTypes.FORCE_CLEAN_ORDER_SELECTED_DASHBOARD});
    
    setTimeout(() => {
      const useWidth = $(DASHBOARD_ID).prop('scrollWidth');
      let scrollHeight = $(PositionUtils.getParentScroll(document.querySelector(DASHBOARD_ID))).prop('scrollHeight');
      let scrollY = -Math.abs(document.documentElement.scrollTop);
      let useHeight = scrollHeight;
      
      html2canvas(document.querySelector(DASHBOARD_ID), {width: useWidth, height: useHeight, scrollY}).then(function(canvas) {
        ReImg.fromCanvas(canvas).downloadPng();
      });
    }, 2000);
  },
  
  componentDidMount() {
    this.refs.leftNav.close();
  },
  
  
  _onTouchLeftMenuBar() {
    this.refs.leftNav.toggle();
  },
  
  _onLeftNavChange(e, key, payload) {
    e.preventDefault();
    if (key > 5) {
      const tab = window.open(Constants.GO_PRO_URL, '_blank');
      tab.focus();
    } else {
      this.context.router.transitionTo(payload.route, payload.param ? payload.param : undefined);
    }
  },
  
  render() {
    let buttonRightBar, appBarContent;
    
    if (Security.loggedIn()) {
      const iconButtonElement = (
        React.createElement(IconButton, {className: "right-option-menu", touch: true}, 
          React.createElement(Avatar, {className: "avatar-applicant", 
                  src: Security.getCurrentApplicantLogoSrc()}, Security.getCurrentUserName())
        )
      );
      const exitIcon = (React.createElement(FontIcon, {className: "material-icons"}, "exit_to_app"));
      const settingIcon = (React.createElement(FontIcon, {className: "material-icons"}, "settings"));
      const printIcon = (React.createElement(FontIcon, {className: "material-icons"}, "print"));
      
      buttonRightBar = getIconMenu.call(this, iconButtonElement, settingIcon, printIcon, exitIcon);
      appBarContent = (
        React.createElement("div", {style: {
          display: 'inline-block',
          lineHeight: 0
        }}, 
          React.createElement("img", {className: "bp-header__app-bar-logo", src: "/assets/images/logo-white_106x35.png"}), 
          React.createElement(Carousel, {onClick: onClickBanner, items: imageList})
        )
      );
    } else {
      buttonRightBar = null;
      appBarContent = null;
    }
    
    let menuItems = [],
      appBarStyle = 'app-bar';
    
    if (Security.loggedIn()) {
      menuItems = [
        {
          route: 'tanks/page/:page',
          param: {page: 0},
          text: t('dashboard_sidebar_tanks_sections'),
          iconClassName: 'icon-bar icon-tanks-sections'
        },
        {
          route: 'styleBeer',
          text: t('dashboard_sidebar_beer_styles'),
          iconClassName: 'icon-bar icon-beer-style-page-icon'
        },
        {route: 'tasks', text: t('dashboard_sidebar_tasks_qc'), iconClassName: 'icon-bar icon-process'},
        {
          route: 'icons-sections',
          text: t('dashboard_sidebar_icons_in_sections'),
          iconClassName: 'icon-bar icon-select-icon'
        },
        {route: 'help', text: t('dashboard_sidebar_help_contact'), iconClassName: 'icon-bar icon-help-page'},
        {
          route: '',
          param: {page: 0},
          text: t('dashboard_sidebar_items'),
          iconClassName: 'icon-bar icon-ingredients is-pro-version',
          permission: 'ADMIN_ITEM_SHOW'
        },
        {
          route: '',
          text: t('dashboard_sidebar_non_inventory_items'),
          iconClassName: 'icon-bar icon-ingredients is-pro-version',
          permission: 'ADMIN_ITEM_SHOW'
        },
        {
          route: '',
          text: t('dashboard_sidebar_products'),
          iconClassName: 'icon-bar icon-group-ingredients is-pro-version',
          permission: 'ADMIN_PRODUCT_SHOW'
        },
        {
          route: '',
          param: {page: 0},
          text: t('dashboard_sidebar_inventory_transfers'),
          iconClassName: 'icon-bar icon-inventory-and-tranfers is-pro-version',
          permission: 'ADMIN_INVENTORY_AND_TRANSFERS_SHOW'
        },
        {
          route: '',
          text: t('dashboard_sidebar_suppliers'),
          iconClassName: 'icon-bar icon-vendors is-pro-version',
          permission: 'ADMIN_VENDOR_SHOW'
        },
        {
          route: '',
          param: {page: 0},
          text: t('dashboard_sidebar_purchase_items'),
          iconClassName: 'icon-bar icon-purchase-items is-pro-version',
          permission: 'ADMIN_PURCHASE_SHOW'
        },
        {
          route: '',
          text: 'Customers',
          iconClassName: 'icon-bar icon-customers is-pro-version',
          permission: 'ADMIN_CUSTOMER_SHOW'
        },
        {
          route: '',
          param: {page: 0},
          text: t('dashboard_sidebar_sales_orders'),
          iconClassName: 'icon-bar icon-Sales-order is-pro-version',
          permission: 'ADMIN_SALE_SHOW'
        },
        {
          route: '',
          text: t('dashboard_sidebar_locations'),
          iconClassName: 'icon-bar icon-locations is-pro-version',
          permission: 'ADMIN_LOCATION_SHOW'
        },
        {
          route: '',
          text: t('dashboard_sidebar_users'),
          iconClassName: 'icon-bar icon-user-access is-pro-version',
          permission: 'ADMIN_USER_PERMISSION_SHOW'
        },
        {
          route: '',
          text: t('dsahboard_sidebar_user_access'),
          iconClassName: 'icon-bar icon-user-access is-pro-version',
          permission: 'ADMIN_USER_PERMISSION_SHOW'
        },
        {
          route: '',
          text: t('dashboard_sidebar_reports'),
          iconClassName: 'icon-bar icon-reports is-pro-version',
          permission: 'ADMIN_REPORT_SHOW'
        }
      ];
      menuItems.unshift({
        route: 'dashboard',
        text: t('dashboard_sidebar_dashboard'),
        iconClassName: 'icon-bar icon-dashboard-page'
      });
      appBarStyle += ' is-login';
    } else {
      menuItems.push({type: MenuItem.Types.LINK, payload: process.env.URL_API + '/#/login', text: 'Log in'});
    }
    
    return (
      React.createElement("div", {
        className: 
          'bp-header app-bar' +
          (Security.loggedIn() ? ' is-login' : '')
        
      }, 
        React.createElement(SettingModal, {
          isOpen: this.state.isSettingModalOpen, 
          onClose: this._toggleSettingModalShow}
        ), 
        React.createElement(AppBar, {
          onLeftIconButtonTouchTap: this._onTouchLeftMenuBar, 
          iconElementRight: buttonRightBar, 
          className: "bp-header__app-bar", 
          style: {
            backgroundColor: '#101112',
            zIndex: 9
          }, 
          ref: "mainAppBar"
        }, 
          appBarContent
        ), 
        React.createElement(LeftNav, {
          ref: "leftNav", 
          style: {fontWeight: '300'}, 
          menuItemClassName: 'app-main__side-bar-item ' + (SessionStore.isFullPaidVersion() ? '' : ' is-free-version'), 
          menuItems: menuItems, 
          docked: false, 
          disableSwipeToOpen: true, 
          onChange: this._onLeftNavChange, 
          selectedIndex: -1, 
          backgroundColor: Colors.indigo900, 
          header: React.createElement(HeaderSideBar, null)}
        )
      )
    );
  }
});

function onClickBanner(item) {
  ga.event({
    category: categories.ADVERTISEMENT_BANNER_CLICK,
    action: actions.CLICK,
    label: `${t('label_banner')} ${get(item, 'name')}`
  });
}

module.exports = Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/HeaderWithBanner.jsx
 **/